import { ApolloQueryResult, gql } from "@apollo/client";
import { LightningElement, api, wire } from "lwc";
import { LabelTranslations, MultiLabelAdapter } from "tbme/localization";
import { QueryAdapter } from "tbme/queryAdapter";
import { PrivateProfileBannerContext } from "./gql/PrivateProfileBannerContext";
export default class extends LightningElement {
  @api isSelf: boolean = undefined!;

  @wire(QueryAdapter, {
    query: gql`
      query PrivateProfileBannerContext {
        siteInfo @client {
          urls {
            trailheadHelpProfileOverview
          }
        }
      }
    `,
  })
  private context: ApolloQueryResult<PrivateProfileBannerContext> = undefined!;

  @wire(MultiLabelAdapter, {
    labels: ["privateProfileMe", "privateProfileMeLink", "privateProfileOther"],
  })
  private labels: LabelTranslations = {};

  get learnMoreUrl() {
    return (
      this.context &&
      this.context.data &&
      this.context.data.siteInfo.urls.trailheadHelpProfileOverview
    );
  }
}
